import { combineReducers } from 'redux';
import analytics from './analytics';
import ui from './ui';
import user from './user';
import iap from '../lib/iap/iap.redux';
import conversation from '../game/conversation/conversation.redux';
import care from '../game/care/care.redux';
import social from '../game/social/social.redux';
import match3 from '../game/minigame/match3/match3.redux';
import level from '../game/level/level.redux';
import pet from '../game/pet/pet.redux';
import duo from '../game/duo/duo.redux';

export default combineReducers({
  analytics,
  ui,
  user,
  pet,
  conversation,
  care,
  social,
  match3,
  level,
  iap,
  duo,
});
